export class FindSupplierParameters {
    pageNumber: number = 0;
    buyerID: number = 0;
    postcode: string = "";
    tradeID: number = 0;
    schemeID: number = 0;
    range: number = 25;
    rangeUnit: string = "m";
    hideBuyerSuppliers: boolean = false;
}